// API Base URL
const language = 'th'
export default language
